/**
 * Marcas do iFood e do 99 Food.
 *
 * O arquivo oficial entra como <img>, e a versao desenhada em CSS fica logo
 * atras, escondida: se a imagem faltar, o onError reexibe ela. Antes isso era
 * uma sondagem em JavaScript testando .webp, .png e .jpg um a um — hoje os
 * arquivos estao versionados no repositorio e sempre existem, entao o caminho
 * direto basta.
 *
 * Quem usa precisa ter a classe `has-logo`, que e o que pinta o fundo da marca.
 */
import { useState } from 'react'

export function BrandIfood({ md = false }: { md?: boolean }) {
  const [falhou, setFalhou] = useState(false)
  return (
    <>
      {!falhou && (
        <img className="brand-img" src="/assets/img/logo-ifood.webp" alt="" onError={() => setFalhou(true)} />
      )}
      <span className={`brand-ifood${md ? ' brand-ifood--md' : ''}`} hidden={!falhou}>
        ifood<i />
      </span>
    </>
  )
}

export function Brand99({ md = false }: { md?: boolean }) {
  const [falhou, setFalhou] = useState(false)
  return (
    <>
      {!falhou && (
        <img className="brand-img" src="/assets/img/logo-99food.webp" alt="" onError={() => setFalhou(true)} />
      )}
      <span className={`brand-99${md ? ' brand-99--md' : ''}`} hidden={!falhou}>
        99<b>Food</b>
      </span>
    </>
  )
}
